import React from 'react';
import { useTranslation } from 'react-i18next';

import { Message } from '@weezevent/nacre';

const BanOrganizerAction = () => {
    const { t } = useTranslation();

    return (
        <Message type="default" title={t('ticket.moderation.statusesTransitions.actions.banOrganizer.messageTitle')}>
            {t('ticket.moderation.statusesTransitions.actions.banOrganizer.messageDescription')}
        </Message>
    );
};

export default BanOrganizerAction;
